<template>
  <div
    class="group relative rounded-2xl overflow-hidden bg-white dark:bg-dark-surface border border-gray-200 dark:border-dark-border hover:shadow-2xl transition-all duration-300 cursor-pointer"
    @click="$emit('open', project)"
  >
    <!-- Image Container -->
    <div class="relative h-64 overflow-hidden">
      <img
        :src="project.image"
        :alt="project.title"
        class="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-400"
      />
      <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

      <!-- Service Tag -->
      <div class="absolute top-4 left-4">
        <span class="px-4 py-1.5 bg-accent text-white text-sm font-semibold rounded-full">
          {{ project.service }}
        </span>
      </div>

      <!-- Hover Overlay -->
      <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div class="text-white text-center">
          <ExternalLink :size="32" class="mx-auto mb-2" />
          <p class="text-sm font-semibold">View Case Study</p>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6">
      <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2 font-display group-hover:text-primary dark:group-hover:text-accent transition-colors duration-300">
        {{ project.title }}
      </h3>

      <p class="text-sm text-gray-500 dark:text-gray-400 mb-3">
        {{ project.client }}
      </p>

      <p class="text-gray-600 dark:text-gray-300 mb-4 line-clamp-2">
        {{ project.description }}
      </p>

      <!-- Technologies -->
      <div class="flex flex-wrap gap-2">
        <span
          v-for="(tech, index) in project.technologies"
          :key="index"
          class="px-3 py-1 bg-gray-100 dark:bg-dark-bg text-gray-700 dark:text-gray-300 text-xs rounded-full"
        >
          {{ tech }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ExternalLink } from 'lucide-vue-next';

defineProps({
  project: {
    type: Object,
    required: true
  }
});

defineEmits(['open']);
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
